<template>
  <template v-if="notifications.length">
    <div class="notifications-wrapper">
      <Notification v-for="notification in notifications" :key="notification.id" :notification="notification" @click="readNotification(notification)"></Notification>
    </div>
    <Button label="Read all" class="p-button-link p-button-sm" @click="readAll" />
  </template>

  <div class="empty-notifications-text" v-else>
    You have no new notifications yet
  </div>

</template>

<script setup>
import Notification from './Notification';
import {useStore} from 'vuex';
import {computed} from 'vue';
import {useNotifications} from '../hooks/useNotifications';
import { useRouter } from 'vue-router';

const {markAsRead, markAllAsRead} = useNotifications();
const store = useStore();
const router = useRouter();

const notifications = computed(() => store.getters['notifications/notifications'])

const readAll = async () => {
  await markAllAsRead();
  await store.dispatch('notifications/setNotifications', []);
}

const readNotification = async ({ id, data, type }) => {
  await markAsRead(id);
  await store.dispatch('notifications/removeNotification', id);

  const route = getRouteForNotification({ data, type });

  if (route) {
    await router.push(route)
  }
}

const getRouteForNotification = ({ data, type }) => {
  if (type === 'MessageNotification') {
    return {name: 'campaign.user', params: {id: data.object.id, userId: data.creator.id}};
  }

  return false;
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";

.notifications-wrapper {
  padding-right: toRem(5);
  max-height: 70vh;
  overflow-y: auto;
  width: toRem(200);
}

.empty-notifications-text {
  font-size: 14px;
  opacity: 0.7;
}
</style>
